import { createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import { ax } from "src/common/api/apiClient";
import { IApi } from "src/common/typings/app";
import {
  INewUser,
  INewUserGroup,
  ISecurityKey,
  IUpdateUser,
  IUpdateUserRole,
} from "src/common/typings/user";
import { ManagementState } from "../managementSlice";
//add general
export const updateNotificationType = createAsyncThunk(
  "management/updateNotificationType",
  async (formRecord: any) => {
    try {
      const res = await ax.put<IApi>("/update_notitifications_type", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
//add general
export const getNotificationType = createAsyncThunk("management/getNotificationType", async () => {
  try {
    const res = await ax.get<IApi>("get_notitifications_type");
    if (res.data.isSuccess === true && res.data.value) return res.data.value;
    else throw new Error(res.data.error || res.statusText);
  } catch (error) {
    throw error;
  }
});

// usersListing 3 methods
export const handleGetUsers = (state: ManagementState, { payload }: PayloadAction<any>) => {
  state.status = "idle";
  state.newUsers = payload;
  // state.newUsers.push(payload);
};
export const handleGetUsersFail = (state: ManagementState) => {
  state.status = "failed";
};
export const getUsersAction = createAsyncThunk(
  "management/getUsersActions", // this is type same like slice name
  async () => {
    try {
      // const res = await ax.get<IApi & { user: IUpdateUser }>(`/get-user-by-user-id/${userId}`);
      const res = await fetchWrapper.get("get-all-users");

      if (res.isSuccess === true) return res.value.usersList;
      else throw new Error(res.statusText);
    } catch (error) {
      // if (error.response.status === 403) {
      // Error here
      // }
      throw error;
    }
  }
);
// addUser 3 methods
export const handleAddUser = (state: ManagementState, { payload }: PayloadAction<any>) => {
  state.status = "idle";
  state.newUsers.push(payload);
};
export const handleAddFail = (state: ManagementState) => {
  state.status = "failed";
};
export const addUserAction = createAsyncThunk(
  "management/addUserAction", // this is type same like slice name
  async (user: INewUser, { dispatch }) => {
    // this is 2nd argument a asynce function
    try {
      const res = await ax.post<IApi>("/create-user", user, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (res.data.isSuccess === true && res.data.value.isCreated === true) {
        return user;
      } else if (res.data.value.isCreated === false) {
        dispatch(
          addNotificationAction({
            message: "Something went wrong!",
            options: { variant: "error" },
          })
        );
      } else {
        throw new Error(res.data.error || res.statusText);
      }
    } catch (error) {
      throw error;
    }
  }
);

// Update User 3 methods
export const handleUpdateUser = (state: ManagementState) => {
  state.status = "idle";
  // state.newUsers.push(payload);
};
export const handleUpdateFail = (state: ManagementState) => {
  state.status = "failed";
};
export const updateUserAction = createAsyncThunk(
  "management/updateUserAction",
  // async ({ userId }: { userId: string }): Promise<IUpdateUser> => {
  async (user: IUpdateUser, { dispatch }) => {
    try {
      const res = await ax.put<IApi>("/update-user", user, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (res.data.isSuccess === true && res.data.value.isUpdated === true) {
        return user;
      } else if (res.data.value.isUpdated === false) {
        dispatch(
          addNotificationAction({
            message: "Something went wrong!",
            options: { variant: "error" },
          })
        );
      } else {
        throw new Error(res.data.error || res.statusText);
      }
    } catch (error) {
      throw error;
    }
  }
);

// Get UserBy ID methods
export const handleGetUser = (state: ManagementState, { payload }: PayloadAction<IUpdateUser>) => {
  state.status = "idle";
  state.currentUser = payload;
  state.currentUserSelectedRoles = payload?.roles;
};
export const handleGetFail = (state: ManagementState) => {
  state.status = "failed";
};
export const getUserAction = createAsyncThunk(
  "management/getUserAction",
  async ({ userId }: { userId: string }): Promise<IUpdateUser> => {
    try {
      const res = await ax.get<IApi>(`/get-user-by-id/${userId}`);
      if (res.data.isSuccess === true) return res.data.value.user;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const handleDeleteFail = (state: ManagementState) => {
  state.status = "failed";
};

export const deleteUserAction = createAsyncThunk(
  "management/deleteUserAction",
  async ({ userId }: { userId: number }, { dispatch }): Promise<IApi> => {
    try {
      const res = await ax.get<IApi>(`/delete-user-by-user-id/${userId}`);
      if (res.status === 200 && res.data.success) {
        dispatch(
          addNotificationAction({
            message: "User deleted successfully!",
            options: { variant: "success" },
          })
        );
        return res.data;
      } else {
        throw new Error(res.data.error || res.statusText);
      }
    } catch (error) {
      throw error;
    }
  }
);

/* Roles & Permissions Start */

export const getRolesAction = createAsyncThunk("management/getRolesAction", async () => {
  try {
    const res = await ax.get<IApi & { roles: string[] }>("/get-all-roles?isActive=true");
    if (res.data.isSuccess === true && res.data.value.roleList) return res.data.value.roleList;
    else throw new Error(res.data.error || res.statusText);
  } catch (error) {
    throw error;
  }
});
export const getRolesListingAction = createAsyncThunk(
  "management/getRolesListingAction",
  async () => {
    try {
      const res = await ax.get<IApi & { roles: string[] }>("/get-all-roles");
      if (res.data.isSuccess === true && res.data.value.roleList) return res.data.value.roleList;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

/* Roles & Permissions Start */

export const getTerminalsAction = createAsyncThunk("management/getTerminals", async () => {
  try {
    const res = await ax.get<IApi>("/terminals_get_all");
    if (res.data.isSuccess === true && res.data.value.terminals) return res.data.value.terminals;
    else throw new Error(res.data.error || res.statusText);
  } catch (error) {
    throw error;
  }
});

export const addUserRoleAction = createAsyncThunk(
  "management/addUserRoleAction",
  async (userGroup: INewUserGroup) => {
    try {
      const res = await ax.post<IApi>("/create-role", userGroup, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const updateUserRoleAction = createAsyncThunk(
  "management/updateUserRoleAction",
  async (userRole: IUpdateUserRole) => {
    try {
      const res = await ax.put<IApi>("/update-role", userRole, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (res.data.isSuccess === true && res.data.value.isUpdated === true) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const getRoleByIdAction = createAsyncThunk(
  "management/getRoleByIdAction",
  async (record: any) => {
    try {
      const res = await ax.post<IApi>("/get-role-by-id", record, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (res.data.isSuccess === true && res.data.value.role) return res.data.value.role;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getAllParentModulesAction = createAsyncThunk(
  "management/getAllParentModules",
  async (terminalId: string) => {
    try {
      // const res = await ax.get<IApi>("/get-all-parent-modules");
      const res = await ax.get<IApi>(`/get-all-parent-child-modules?terminalId=${terminalId}`);
      if (res.data.isSuccess === true && res.data.value.modules) return res.data.value.modules;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const getAllChildModulesAction = createAsyncThunk(
  "management/getAllChildModulesAction",
  async (id: number) => {
    try {
      const res = await ax.get<IApi>(`/get-all-child-modules/${id}`);
      if (res.data.isSuccess === true && res.data.value.modules) return res.data.value.modules;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const assignRolesModulesAction = createAsyncThunk(
  "management/assignRolesModulesAction",
  async (record: any) => {
    try {
      const res = await ax.post<IApi>("/role_action_update", record, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const getSelectedModuleCheckboxesAction = createAsyncThunk(
  "management/getSelectedModuleCheckboxesAction",
  async (record: any) => {
    try {
      const res = await ax.post<IApi>("/get-role-actions", record, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
/* Roles & Permissions End */

export const handleGetRoleByName = (
  state: ManagementState,
  { payload }: PayloadAction<IUpdateUser>
) => {
  state.status = "idle";
  state.currentUser = payload;
};
export const handleGetRoleByNameFail = (state: ManagementState) => {
  state.status = "failed";
};

export const getRoleByNameAction = createAsyncThunk(
  "management/getRoleByNameAction",
  async (roleName: string): Promise<any> => {
    try {
      const res = await ax.get<IApi & IUpdateUserRole>(
        `/get-role-by-role-name/${encodeURI(roleName)}`
      );
      if (res.status === 200 && res.data.success) {
        // setUserGroupId(res.data.roleId);
        // const securityKeys = res.data.securityKeys?.join(",").split(",");
        // setUserRoleSecurityKeys(securityKeys);
        return res.data;
      } else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const resetPasswordAction = createAsyncThunk(
  "management/resetPasswordAction",
  async (user: any, { dispatch }) => {
    try {
      const res = await ax.get<IApi>(`/reset-user-password-by-user-id/${user.userId}`, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (res.status === 200 && res.data.success) {
        dispatch(
          addNotificationAction({
            message: "Password reset request has been processed!",
            options: { variant: "success" },
          })
        );
        return user;
      } else {
        throw new Error(res.data.error || res.statusText);
      }
    } catch (error) {
      // dispatch(
      //   addNotificationAction({
      //     message: error.message,
      //     options: { variant: "error" },
      //   })
      // );
      throw error;
    }
  }
);
export const getSecurityKeys = createAsyncThunk("management/getSecurityKeys", async (): Promise<
  ISecurityKey[]
> => {
  try {
    const res = await ax.get<IApi & { securityKeys: ISecurityKey[] }>("/get-security-keys");
    if (res.status === 200 && res.data.success)
      if (res.data.securityKeys && res.data.securityKeys.length) return res.data.securityKeys;
      else return [];
    else throw new Error(res.data.error || res.statusText);
  } catch (error) {
    throw error;
  }
});
